@let formValue = form();
@let loadingValue = loading();
@let licenseTypesLoadingValue = licenseTypesLoading();
@let licenseTypesLoadedValue = licenseTypesLoaded();
@let licenseTypesWithDisplayNameValue = licenseTypesWithDisplayName();
@let isOnlyOneOptionAvailableValue = isOnlyOneOptionAvailable();
@let availableLicensesValue = availableLicenses();
@let trialAvailableLicense = availableLicensesValue?.[ChangeLicenseCase.TRIAL];
@let paidAvailableLicense = availableLicensesValue?.[ChangeLicenseCase.PAID];
@let buyAvailableLicense = availableLicensesValue?.[ChangeLicenseCase.BUY];
@let poolAvailableLicense = availableLicensesValue?.[ChangeLicenseCase.POOL];

@if (companyLoading()) {
  <mbs-loader></mbs-loader>
}

<div [formGroup]="formValue">
  <fieldset class="mbs-form_content">
    <mbs-select
      formControlName="selectedLicenseType"
      [appendTo]="'.modal-content'"
      [bindLabel]="'displayName'"
      [bindValue]="'id'"
      [disabledSelf]="licenseTypesLoadingValue || !licenseTypesWithDisplayNameValue.length"
      [items]="licenseTypesWithDisplayNameValue"
      [label]="label"
      [loading]="licenseTypesLoadingValue || loadingValue"
      [placeholder]="
        licenseTypesWithDisplayNameValue.length || licenseTypesLoadingValue || !licenseTypesLoadedValue
          ? ('shared:licenses.management.selectLicenseType' | i18next)
          : ('shared:licenses.management.noLicenseAllowed' | i18next)
      "
      [showRequiredMark]="false"></mbs-select>

    @if (isNotAllowedLicense() && ('Provider' | can: 'read')) {
      <mbs-alert
        class="mb-0 mt-2"
        [icon]="true">
        The selected license type is not allowed for this company based on its settings. However, your role allows overriding this setting
        and assign any license type.
        <a
          [queryParams]="{ tab: 'licensesTab' }"
          [routerLink]="[companyLicenseSettingsLink()]"
          >Manage settings</a
        >
      </mbs-alert>
    }

    @if (companyHasRestrictions() && ('SubAdmin' | can: 'read')) {
      <mbs-alert
        class="mb-0 mt-2"
        [icon]="true">
        This list contains only the license types allowed by the company settings
      </mbs-alert>
    }

    <ng-template #label>
      <div>
        @if (isPostPayment()) {
          {{ 'shared:common.license' | i18next }}
        } @else {
          {{ 'shared:licenses.management.licenseType' | i18next }}
        }
      </div>

      @if (isShownLicenseSettingsLink()) {
        <div class="text-sm text-gray fw-normal">
          {{ 'shared:licenses.management.selectLicenseModalComponent.manageLicenseTypes' | i18next }}
          <a
            [queryParams]="{ tab: 'licensesTab' }"
            [routerLink]="[licenseSettingsLink()]"
            >{{ isCompanyPool() ? 'Company settings' : 'User settings' }}</a
          >
        </div>
      }
    </ng-template>
  </fieldset>

  @if (!loadingValue && !isNil(formValue.value.selectedLicenseType) && availableLicensesValue) {
    <fieldset class="mbs-form_content mt-3">
      <mbs-input-label
        [boldLabel]="true"
        [label]="'shared:licenses.management.availableLicenses' | i18next"></mbs-input-label>

      @switch (true) {
        @case (paidAvailableLicense && isOnlyOneOptionAvailableValue) {
          <div>
            {{ paidAvailableLicense.label }}
          </div>
        }
        @case (trialAvailableLicense && isOnlyOneOptionAvailableValue) {
          <div>
            {{ trialAvailableLicense.label }}
          </div>
        }
        @case (buyAvailableLicense && isOnlyOneOptionAvailableValue) {
          <div>
            {{ buyAvailableLicense.label }}
          </div>
        }
        @default {
          @if (paidAvailableLicense) {
            <mbs-radio
              formControlName="changeLicenseCase"
              [label]="paidAvailableLicense.label"
              [value]="paidAvailableLicense.value"></mbs-radio>
          }

          @if (buyAvailableLicense) {
            <mbs-radio
              formControlName="changeLicenseCase"
              [disabledSelf]="administratorMode()"
              [label]="buyAvailableLicense.label"
              [value]="buyAvailableLicense.value"></mbs-radio>
          }

          @if (trialAvailableLicense !== false) {
            <mbs-radio
              formControlName="changeLicenseCase"
              [label]="trialAvailableLicense.label"
              [value]="trialAvailableLicense.value"></mbs-radio>
          }

          @if (poolAvailableLicense) {
            <mbs-radio
              formControlName="changeLicenseCase"
              [label]="poolAvailableLicense.label"
              [value]="poolAvailableLicense.value">
              <ng-template radioDescription>
                <mbs-select
                  formControlName="selectedAnotherPoolLicense"
                  [appendTo]="'.modal-content'"
                  [bindLabel]="'selectedLabel'"
                  [bindValue]="'licenseId'"
                  [disabledSelf]="formValue.get('changeLicenseCase').value !== poolAvailableLicense.value"
                  [items]="availablePaidLicenses()"
                  [placeholder]="'shared:licenses.management.selectLicenseModalComponent.selectPool' | i18next">
                  <ng-template
                    #mbsSelectOptionTmp
                    let-index="index"
                    let-item="item"
                    let-search="searchTerm">
                    <div class="d-flex justify-content-between">
                      <div class="px-0">
                        <span class="text-gray-900">{{ item.poolName }}</span>

                        <div class="text-xs">
                          <mbs-text-ellipsis [tooltip]="item.name">
                            {{ item.name }}
                          </mbs-text-ellipsis>
                        </div>
                      </div>

                      <div class="text-gray-600 text-end">
                        <div class="col-auto px-0 text-md">
                          {{ 'shared:licenses.management.selectLicenseModalComponent.licenses' | i18next: { count: item.count } }}
                        </div>
                        <div class="text-xs">
                          {{
                            'shared:licenses.management.selectLicenseModalComponent.validUntil'
                              | i18next
                                : {
                                    count: isGlobalPool(item) ? 1 : item.count,
                                    date: item.validUntil | date
                                  }
                          }}
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </mbs-select>
              </ng-template>
            </mbs-radio>
          }
        }
      }
    </fieldset>
  }
</div>
